import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { submitVerification } from '../../../services/verificationRequest';

interface IProps {
  crmId: number;
  code: string;
}
export const ThunkConfirmValidation = createAsyncThunk<boolean, IProps>(
  `${storeResources.VERIFICATION_REQUEST}/confirmValidation`,
  ({ crmId, code }) => submitVerification({ crmId, code }).then(res => res.data),
);
